import { render, staticRenderFns } from "./Lectoras.vue?vue&type=template&id=17473dd6&"
import script from "./Lectoras.vue?vue&type=script&lang=js&"
export * from "./Lectoras.vue?vue&type=script&lang=js&"
import style0 from "./Lectoras.vue?vue&type=style&index=0&id=17473dd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports